import React, { useState, useEffect } from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    ScrollView,
    Image,
    ActivityIndicator,
    Linking,
    Platform
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import axios from 'axios';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/DetalheAnaliseStyles';
import { useLogScreen } from '../../useLogScreen';
export default function AnaliseDetalheWeb({ route }) {
    useLogScreen('AnaliseDetalheWeb');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Detalhes';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const { id = null } = route.params || {};
    const [analiseData, setAnaliseData] = useState({});
    const [proprietario, setProprietario] = useState({});
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);

    const getStatusText = (status) => {
        switch (status) {
            case 'em_progresso':
                return 'Em Progresso';
            case 'concluida':
                return 'Concluída';
            case 'pendente':
                return 'Pendente';
            default:
                return status;
        }
    };

    // const formatDate = () => {
    //     const data = analiseData.data_analise;
    //     if (data) {
    //         const [year, month, day] = data.split('-');
    //         return `${day}/${month}/${year}`;
    //     }
    //     return 'Data inválida';
    // };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do 0
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const analiseResponse = await axios.get(`https://analise3.imogo.com.br/analises/full/${id}`);
            setAnaliseData(analiseResponse.data);

            const response = await axios.get(`https://analise3.imogo.com.br/analises/${id}/proprietarios`);
            const data = response.data;
            setProprietario(data);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        <BaseWeb>
            {(user) => {
                if (!userInfo) setUserInfo(user);

                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Análise #{id}</Text>

                        {loading ? (
                            <ActivityIndicator size="large" color="#730d83" />
                        ) : (
                            <View style={styles.container}>
                                <View style={styles.areaRow}>
                                    <View style={styles.areaColumn}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Endereço do imóvel: {analiseData.imovel?.endereco}</Text>
                                    </View>
                                    <View style={styles.areaColumn}>
                                        <Text style={[styles.subLabel, styles.cardStatus(analiseData.status)]} allowFontScaling={false}>
                                            Status: {getStatusText(analiseData.status)}
                                        </Text>
                                    </View>
                                </View>

                                <View style={styles.areaRow}>
                                    <View style={styles.areaColumn}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Matrícula & Cartório: {analiseData.imovel?.matricula} do {analiseData.imovel?.cartorio}</Text>
                                    </View>
                                    <View style={styles.areaColumn}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Inscrição do IPTU: {analiseData.imovel?.inscricao_iptu}</Text>
                                    </View>
                                </View>

                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Nome Completo: {proprietario[0]?.nome_razao}</Text>
                                </View>

                                <View style={styles.divider} />

                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Data da solicitação: {formatDate(analiseData.data)}</Text>
                                </View>

                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Resumo: {'\n'}"{analiseData.resumo}"</Text>
                                </View>
                                {/* Botão extra para voltar à lista */}
                                <View style={styles.buttonsRow}>
                                    {analiseData.link_pdf && (
                                        <TouchableOpacity
                                            style={styles.outlinedButton}
                                            onPress={() => Linking.openURL(analiseData.link_pdf)}
                                        >
                                            <Image
                                                source={require('../../assets/icons/download.png')}
                                                style={styles.outlinedIcon}
                                            />
                                            <Text style={styles.outlinedText}>Baixar Análise</Text>
                                        </TouchableOpacity>
                                    )}
                                    <TouchableOpacity
                                        style={styles.outlinedButton}
                                        onPress={() => navigation.navigate('ListaAnaliseWeb')}
                                    >
                                        <Image
                                            source={require('../../assets/icons/bookmark.png')}
                                            style={styles.outlinedIcon}
                                        />
                                        <Text style={styles.outlinedText}>Voltar para Lista</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        )}
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
